<script lang="ts">
  import type { Snippet } from 'svelte';

  let { children }: {children?: Snippet} = $props();
</script>

<div class="container py-5 text-center fst-italic">
  <div>
    {#if children}
      {@render children()}
    {:else}
      Loading...
    {/if}
  </div>
</div>
